import styled from 'styled-components';
import { colours, fonts } from 'themes/default';
import AlertBox from 'components/ui/AlertBox';
import { BREAKPOINTS } from 'constants/breakpoints';

const { fontStyleRegular } = fonts;
const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledAlertBox = styled(AlertBox)`
  margin: 8px 0;
`;

const StyledHeading = styled.h2`
  ${fontStyleRegular}
  font-weight: 600;
  margin-bottom: 4px;
`;

const StyledOriginDestination = styled.span`
  font-weight: normal;
`;

const LegContainer = styled.div`
  border: 1px solid ${colours.Greyscale.CharcoalGrey};
  margin-bottom: 28px;
`;

const LegDetails = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    white-space: nowrap;
    overflow-x: scroll;
  }
`;

const TrainDetails = styled.div`
  width: 15%;
  border-right: 1px solid ${colours.Greyscale.CharcoalGrey};
  padding-right: 16px;

  > p {
    font-size: clamp(10px, 1vw, 16px);
  }
`;

const PassengerDetails = styled.div`
  flex-grow: 1;
  margin-left: 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    table th:last-child,
    table td:last-child {
      position: sticky;
      right: -16px;
      border: solid 1px ${colours.Greyscale.Eggshell};
      background: ${colours.Greyscale.Eggshell};
      padding: 0px 16px;
    }

    table th:nth-last-child(2),
    table td:nth-last-child(2) {
      position: sticky;
      right: 30px;
      border: solid 1px ${colours.Greyscale.Eggshell};
      background: ${colours.Greyscale.Eggshell};
    }
  }
`;

const StyledTooltip = styled.abbr`
  text-decoration: underline;
  cursor: default;
`;

const StyledTitle = styled.em`
  font-weight: 600;
  font-style: normal;
`;

const BrandIcon = styled.img`
  width: ${(props) => (props.$small ? '2em' : '4em')};
  height: 1.625em;
  margin-right: 2px;
`;

const AdditionalNotesIcon = styled.img`
  height: 16px;
  margin-left: 4px;
`;

const TrainNumber = styled.span`
  display: flex;
  align-items: center;
`;
const TrainNumberContainer = styled.p``;

export {
  AdditionalNotesIcon,
  BrandIcon,
  LegContainer,
  LegDetails,
  TrainDetails,
  PassengerDetails,
  StyledHeading,
  StyledOriginDestination,
  StyledTooltip,
  StyledTitle,
  TrainNumber,
  TrainNumberContainer
};
